// extracted by mini-css-extract-plugin
export default {"cls1":"AppearanceForm-Grid_cls1__3YQcH","cls2":"AppearanceForm-Grid_cls2__ZLAtH AppearanceForm-Grid_cls1__3YQcH"};